// GENERATED by scripts/build-icons.mjs from icons/x.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const X = createIcon('x', [
  ['path', { d: "M18 6 6 18" }],
  ['path', { d: "m6 6 12 12" }],
])
